import { AxiosResponse } from 'axios'
import { VerificaAuthData } from '~/interfaces'
import { CreateAxiosInstance } from '~/modules'

const { REACT_APP_API_TELEMEDICINE_URL: telemedicineApi } = process.env

export const renewOTP = async (params: {
  username: string
  password: string
}): Promise<AxiosResponse<VerificaAuthData>> => {
  const { axios: authInstance } = CreateAxiosInstance()
  return await authInstance.post(`${telemedicineApi}/session/verifica/`, { ...params })
}
